<template>
  <section class="module-about">
     <NavComponent></NavComponent>
    <div class="bg">
      <div class="container">
        <p class="add-pointer" @click="goRelationPage"><span>秘邻</span>是短视频营销平台，也是企业全员营销赋能方案供应商<br />通过人工智能、短视频和互联网技术，赋能企业从视频主页到私域推广，品效结合的OmniVideo视频营销解决方案。</p>
      </div>
    </div>
    <div class="title">
      <img src="../assets/about3.png" alt="about">
    </div>
    <div class="container jd2">
        <p style="text-align:center;">量子像素（北京）科技有限公司，创立短视频营销平台，并赋能企业全员营销方案。通过人工智能、短视频和互联网技术，赋能企业从视频主页到私域推广，品效结合的OmniVideo全视频营销解决方案，实现精准营销。我们提供的服务</p>
        <p style="color:#07C160;cursor:pointer" @click="goRelationPage">商户赋能</p>
        <p>● B2B2C模式。提供各类短视频营销工具，赋能商家建立短视频旺铺。</p>
        <p>● 量子大学。赋能短视频生态，搭建短视频营销达人体系，助力成长型企业把握短视频行业风口。</p>
        <p style="color:#07C160;cursor:pointer" @click="goRelationPage">精准营销</p>
        <p>● 深耕微信生态，及各大短视频平台，品效结合的OmniVideo全视频营销解决方案。</p>
        <p>● 精准营销，提供更实效的商品、商机以及到店转化。</p>
    </div>

    <FooterComponent></FooterComponent>
  </section>
</template>

<script>
import NavComponent from '@/components/header.vue'
import FooterComponent from '@/components/footer.vue'
import util from "../util/util.js";
export default {
  components: {
    NavComponent,
    FooterComponent
  },
  data(){
    return{

    }
  },
  methods: {
    goRelationPage(){
      util.goContact();
    }
  }
}
</script>

<style lang="scss" scoped>
.module-about {
  .ceo img {
    border-radius: 10px;
    width: 260px;
  }
  @media screen and (min-width: 769px){
      .bg {
            padding-top: 50px;
            height: 300px;
            background: url("../assets/product_banner.png") center bottom no-repeat;
            background-size: 100% 100%;
            p {
                color: #07C160;
                font-size: 16px;
                font-weight: bold;
            }
            span {
              font-size: 28px;
            }
          }
  }
  // .bg {
  //   padding-top: 50px;
  //   height: 300px;
  //   background: url("../assets/product_banner.png") center bottom no-repeat;
  //   background-size: 100% 100%;
  //   p {
  //       color: #07C160;
  //       font-size: 16px;
  //       font-weight: bold;
  //   }
  //   span {
  //     font-size: 28px;
  //   }
  // }
  .jd {
    color: #000;
    .name {
      font-size: 1.5rem;
    }
  }
  .jd2 {
    text-indent: 2em;
    line-height: 1.8;
    
  }
  .container {
    .add-pointer{
      cursor: pointer;
    }
    .set-center{
      text-align: center;
    }
  }
  .title {
    padding: 4rem 0;
    text-align: center;
    img {
      width: 100%;
      max-width: 495px;
    }
  }

  @media screen and (max-width: 768px){
      & {
          .bg {
            height: 12rem;
            background: url("../assets/product_banner.png") center bottom no-repeat;
            background-size: 100% 100%;
            p {
                color: #07C160;
                font-size: 0.9rem;
                font-weight: bold;
            }
            span {
              font-size: 28px;
            }
          }

          .title {
              padding: 1rem 0;
          }

          .jd p {
            margin-bottom: 0;
          }
      }
  }

}
</style>
